module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_Black-caa1c95a194008fd2b782d1a73001903.svg";